import React from "react";
import { motion, AnimatePresence } from "framer-motion";

// Renders a soft, premium banner for the currently selected category. Hidden
// when no banner is configured or "All" is selected.
export const CategoryBanner = ({ category, banners }) => {
  const banner =
    category && category !== "All"
      ? banners.find((b) => b.category === category)
      : null;

  return (
    <AnimatePresence mode="wait">
      {banner ? (
        <motion.section
          key={banner.category}
          data-testid={`category-banner-${banner.category.toLowerCase()}`}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.45, ease: "easeOut" }}
          className="relative overflow-hidden rounded-3xl border border-white/60 shadow-[0_18px_48px_rgba(0,0,0,0.10)]"
        >
          <div className="aspect-[16/6] sm:aspect-[16/5] relative">
            <img
              src={banner.image}
              alt={`${banner.category} banner`}
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#022C22]/55 via-[#022C22]/15 to-transparent" />
            <div className="absolute left-5 sm:left-9 top-1/2 -translate-y-1/2 max-w-[55%]">
              <p className="text-[10px] sm:text-[11px] uppercase tracking-[0.28em] text-[#E0B53C] font-semibold mb-2">
                {banner.category}
              </p>
              <h3 className="font-display text-2xl sm:text-4xl text-white leading-tight">
                The {banner.category} edit.
              </h3>
            </div>
          </div>
        </motion.section>
      ) : null}
    </AnimatePresence>
  );
};
